import { useState, useEffect } from "react";
import isBrowserContext from "helpers/isBrowserContext";
import { useGTMDispatch } from "@elgorditosalsero/react-gtm-hook";
import { SiteSettings } from "app/umbraco/models/settings.model";

export default (settings?: SiteSettings, history?: any) => {
    const [originalLocation, setOriginalLocation] = useState<string | undefined>(undefined);
    const sendDataToGTM = useGTMDispatch();

    useEffect(() => {
        if (isBrowserContext()) {
            window.dataLayer = window.dataLayer || [];

            if (history) {
                // Fixes "The Rogue Referral Problem" for Single-page sites
                // https://www.simoahava.com/gtm-tips/fix-rogue-referral-problem-single-page-sites/
                const location = document.location.protocol + "//" + document.location.hostname + document.location.pathname + document.location.search;
                if (typeof (originalLocation) === "undefined") {
                    setOriginalLocation(location);
                }

                // Trigger on all sites
                sendDataToGTM({
                    "event": "Heyday.FirstPageview",
                    "eventTimeout": 2000,
                    "originalLocation": location,
                    "website_venueId": settings?.venueId ?? "",
                    "website_gaId": settings?.googleAnalyticsId ?? ""
                });

                // Trigger for all other pages after this
                let previousUrl = "";
                history.listen((updatedLocation: any) => {
                    const url = updatedLocation.pathname + updatedLocation.search;

                    if (previousUrl !== url) {
                        previousUrl = url;

                        sendDataToGTM({
                            "event": "Heyday.Pageview",
                            "eventTimeout": 2000,
                            "originalLocation": location,
                            "website_venueId": settings?.venueId ?? "",
                            "website_gaId": settings?.googleAnalyticsId ?? ""
                        });
                    }
                });
            }
        }
    }, []);

    return;
};